import { useLanguage } from "@/context/LanguageContext";
import { MapPin } from "lucide-react";

const Coverage = () => {
  const { t, lang } = useLanguage();
  const areas = t("coverage.areas") || [];

  return (
    <section
      id="coverage"
      data-testid="coverage-section"
      className="py-20 md:py-28 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-3xl">
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#FF5A00]">
            {t("coverage.eyebrow")}
          </div>
          <h2
            className="mt-4 text-4xl md:text-5xl lg:text-6xl font-black tracking-tight text-[#0B1320] leading-[1.05]"
            style={{
              fontFamily:
                lang === "ar" ? "Tajawal, sans-serif" : "Outfit, sans-serif",
            }}
          >
            {t("coverage.title")}
          </h2>
          <p className="mt-5 text-lg text-[#475569] max-w-2xl">
            {t("coverage.subtitle")}
          </p>
        </div>

        <div className="mt-10 flex items-center gap-3 flex-wrap">
          <MapPin size={16} className="text-[#FF5A00]" />
          {areas.map((a, i) => (
            <span
              key={i}
              data-testid={`coverage-area-${i}`}
              className={`inline-flex items-center h-10 px-4 rounded-full text-sm font-bold transition-colors ${
                i === 0
                  ? "bg-[#FF5A00] text-white"
                  : "bg-[#FAF9F6] text-[#0B1320] border border-[#E2DFD2]"
              }`}
            >
              {a}
            </span>
          ))}
          <span className="inline-flex items-center h-10 px-4 rounded-full text-sm font-semibold bg-white text-[#475569] border border-dashed border-[#E2DFD2]">
            + {t("coverage.soon")}
          </span>
        </div>
      </div>
    </section>
  );
};

export default Coverage;
